import { ListPage } from 'b2b-apps/core/manufacturer/components/ListPage';
export default ListPage;
export * from 'b2b-apps/core/manufacturer/components/ListPage';
